import { render, staticRenderFns } from "./_loading-text.vue?vue&type=template&id=7755f250&scoped=true&lang=pug&"
import script from "./_loading-text.vue?vue&type=script&lang=js&"
export * from "./_loading-text.vue?vue&type=script&lang=js&"
import style0 from "./_loading-text.vue?vue&type=style&index=0&id=7755f250&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.5_snackhrvn2skq2fk5zrw2w5ryi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7755f250",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cj/Documents/Work/the-wedding/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7755f250')) {
      api.createRecord('7755f250', component.options)
    } else {
      api.reload('7755f250', component.options)
    }
    module.hot.accept("./_loading-text.vue?vue&type=template&id=7755f250&scoped=true&lang=pug&", function () {
      api.rerender('7755f250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_common/_loading-text.vue"
export default component.exports